"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _default = {
  badge: "Placa",
  close: "Cerrar",
  dataIterator: {
    noResultsText: "Ningún elemento coincide con la búsqueda",
    loadingText: "Cargando..."
  },
  dataTable: {
    itemsPerPageText: "Filas por página:",
    ariaLabel: {
      sortDescending: ": Orden descendente. Pulse para quitar orden.",
      sortAscending: ": Orden ascendente. Pulse para ordenar descendente.",
      sortNone: ": Sin ordenar. Pulse para ordenar ascendente.",
      activateDescending: ": Activar orden descendente",
      activateAscending: ": Activar orden ascendente",
      activateNone: ": No activar nada"
    },
    sortBy: "Ordenado por"
  },
  pagination: {
    ariaLabel: {
      previous: "Anterior",
      page: "Página",
      next: "Siguiente",
      wrapper: "Contenedor",
      currentPage: "Página actual"
    }
  },
  dataFooter: {
    itemsPerPageText: "Elementos por página:",
    itemsPerPageAll: "Todos",
    nextPage: "Página siguiente",
    prevPage: "Página anterior",
    firstPage: "Primer página",
    lastPage: "Última página",
    pageText: "{0}-{1} de {2}"
  },
  datePicker: {
    itemsSelected: "{0} seleccionados",
    prevMonthAriaLabel: "Mes anterior",
    nextMonthAriaLabel: "Mes siguiente",
    prevYearAriaLabel: "Año anterior",
    nextYearAriaLabel: "Año siguiente"

  },
  noDataText: "No hay datos disponibles",
  carousel: {
    prev: "Visual anterior",
    next: "Visual siguiente",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} más"
  },
  fileInput: {
    counter: "{0} archivos",
    counterSize: "{0} archivos ({1} en total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM"
  },


  code: "Código",
  instance: "Instancia",
  masteraccount: "Cuenta raíz",
  master_account_code: "Cuenta raíz",
  masteraccount_code: "Cuenta raíz",
  subaccount_code: "Subcuenta",
  workflow_template_code: "Plantilla",
  template_code: "Plantilla",
  template: "Plantilla",
  email_entity: "P. Email",
  sms_provider: "P. SMS",
  postal_envelope: "Sobre",
  is_b2b: "Portal B2B",
  is_deleted: "Borrado",
  process: "Proceso",
  process_code: "Código de proceso",
  master_account: "Cuenta raíz",
  group_name: "Grupo",
  project_code: "Proyecto",
  analytical_unit: "U. Analítica",
  billing_unit: "U. Facturación",
  "OR": "Búsqueda",
  creation_timestamp: "Creación",
  deletion_timestamp: "Borrado",
  deleted: "Borrada",
  source: "Origen",
  macrostatus: "Macroestado",
  username: "Email",
  group_id: "ID Grupo",
  timestamp: "Fecha",
  instance_code: "Instancia",
  notification_recipient: "Destinatario",
  notification_channel: "Canal",
  createdAt: "Fecha",
  action: "Acción",
  certificate_issuer: "Emisor Cert.",
  week_average_current_year: "media semanal del año",
  week_average_previous_year: "media semanal año anterior",
  last_year_month: "mismo mes, año anterior",
  month_day_average_current_year: "media diaria del año",
  month_day_average_previous_year: "media diaria año anterior",
  last_month: "Mes anterior",
  user_qa_username: "QA Tester",
  user_pmo_username: "Jefe de proyecto",
  status: "Estado",
  billing_status: "Estado de facturación",
  billing_platform: "Plataforma de facturación",
  billing_comments: "Comentarios de facturación",
  user_operation_username: "Operador",
  level: "Level",
  context: " Context",
  process_properties: {
    id: "ID",
    workflow_template_code: "Plantilla",
    appearance_code: "Apariencia",
    code: "Código",
    name: "Nombre",
    certificates_expiration_days: "Expiración certificado",
    default_language: "Idioma por defecto",
    certification_entity_name: "Entidad certificadora",
    auth_method: "Autenticación",
    auth_username: "Usuario",
    auth_password: "Contraseña",
    auth_certificate_serial: "Serial Certificado",
    email_entity: "Proveedor email",
    email_login: "Usuario",
    email_pwd: "Contraseña",
    commstracker_domain_sms: "Dominio Commstracker SMS",
    commstracker_domain_email: "Dominio Commstracker email",
    sms_provider: "Proveedor SMS",
    pdf_format_ts_events: "Formato PDF Eventos",
    pdf_format_certificates: "Formato PDF Certificado",
    email_stream_type: "Tipo de email",
    postal_envelope: "Sobre postal",
    certificate_language: "Idioma del certificado",
    stopped: "¿Proceso parado?",
    intromission_api_bitmask: "Api intromisión",
    of: "OF",
    project_code: "Código proyecto",
    project_name: "Nombre proyecto",
    subaccount_code: "Código subcuenta",
    subaccount_name: "Nombre subcuenta",
    master_account_code: "Código cuenta raíz",
    master_account_name: "Nombre cuenta raíz",
    postamail_login: "Usuario Postamail",
    postamail_password: "Contraseña Postamail",
    postamail_sftp_login: "Usuario SFTP (PM)",
    postamail_sftp_password: "Contraseña SFTP (PM)",
    is_b2b: "¿Activo en B2B?",
    communicalia_sync: "Sincronización Communicalia",
    billing_automated: "¿Fact. Auto?",
    enquiry_api_bitmask: "API de consulta",
    default_billing_unit: "Unidad de facturación",
    default_analytical_unit: "Unidad analítica",
    certificate_issuer: "Emisor del certificado",
    qualified_texts: "¿Certificado cualificado?",
    certificate_provider: "Proveedor del certificado",
    seal_provider: "Proveedor SDT",
    tsa_provider: "Proveedor TSA",
    macrostatus_callbacks: "Callbacks en macroestado",
    whatsapp_sender: "Sender WhatsApp",
    whatsapp_client_id: "ID Cliente WhatsApp",
    whatsapp_client_secret: "Secret WhatsApp",
    whatsapp_api_id: "API ID WhatsApp"
  }
};
exports.default = _default;
//# sourceMappingURL=es.js.map
